// src/screens/Feedback/FeedbackForm.js
import React, { useRef, useState } from 'react';
import api from '../../api';
import './FeedbackForm.css';

import backIcon from '../../assets/backarrow-icon.png';
import addIcon from '../../assets/add-icon.png';
import closeIcon from '../../assets/close-icon.png';

function FeedbackForm({ user, navigateBack }) {
  const [text, setText] = useState('');
  const [type, setType] = useState('bug'); // NEW: feedback type state
  const [media, setMedia] = useState([]);
  const fileInputRef = useRef();
 const [toast, setToast] = useState({ visible: false, message: '', type: '' }); // type = success | error

  const handleMediaChange = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = [...media, ...files];

    const images = newFiles.filter((file) => file.type.startsWith('image/')).slice(0, 5);
    const video = newFiles.find((file) => file.type.startsWith('video/'));
    const final = [...images];
    if (video) final.push(video);
    setMedia(final);
    e.target.value = '';
  };

  const handleRemoveFile = (index) => {
    setMedia((prev) => prev.filter((_, i) => i !== index));
  };


const showToast = (message, type = 'success') => {
  setToast({ visible: true, message, type });
  setTimeout(() => {
    setToast({ visible: false, message: '', type: '' });
    if (type === 'success') {
      navigateBack(); // auto-go-home on success
    }
  }, 2500);
};


  const handleSubmit = async () => {
    if (!text.trim()) return alert('Please describe the issue or suggestion.');

    const formData = new FormData();
    formData.append('text', text);
    formData.append('type', type); // NEW: append type
    formData.append('username', user.username);
    media.forEach((file) => formData.append('media', file));

try {
  await api.post('/feedback', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  showToast(' Feedback submitted successfully!', 'success');
  setText('');
  setMedia([]);
  setType('bug');
} catch (err) {
  console.error('❌ Feedback submission failed:', err);
  showToast('Failed to submit feedback.', 'error');
}

  };

  return (
    <div className="feedback-container">
      {/* Fixed Header */}
      <div className="feedback-header">
        <img src={backIcon} onClick={navigateBack} alt="back" />
        <h2>Send Feedback</h2>
      </div>

      {/* Scrollable Body */}
      <div className="feedback-body scrollable">
        <label>Feedback Type</label>
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="feedback-select"
        >
          <option value="bug">🐞 Bug</option>
          <option value="suggestion">💡 Suggestion</option>
        </select>

        <label>Description</label>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Describe the bug or suggestion..."
        />

        <label>Attachments (max 5 images, 1 video)</label>
        <div className="feedback-media-preview">
          {media.map((file, i) => (
            <div key={i} className="preview-thumb">
              {file.type.startsWith('video') ? (
                <video src={URL.createObjectURL(file)} controls />
              ) : (
                <img src={URL.createObjectURL(file)} alt="preview" />
              )}

<div className="feedback-remove-icon" onClick={() => handleRemoveFile(i)}>

                <img src={closeIcon} alt="remove" />
              </div>
            </div>
          ))}
          {media.length < 6 && (
            <div className="add-media-box">
              <label htmlFor="feedback-media">
                <img src={addIcon} alt="Add" />
              </label>
              <input
                id="feedback-media"
                type="file"
                accept="image/*,video/*"
                multiple
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleMediaChange}
              />
            </div>
          )}
        </div>
      </div>


   
   <div className="feedback-footer">
        <button className="submit-feedback-btn" onClick={handleSubmit}>
          Submit Feedback
        </button>
      </div>

{toast.visible && (
  <div className={`feedback-toast ${toast.type}`}>
    {toast.message}
  </div>
)}



    </div>

  );
}

export default FeedbackForm;
